import { useContext, useEffect, useState } from 'react';
import { Button, Modal, ModalDialog, Stack, Typography } from '@mui/joy';
import { LayoutContext } from '../../context';
import PersonAddAltRounded from '@mui/icons-material/PersonAddAltRounded';
import { APIAttachApplicationCabinet } from '../../api';
import CabinetAccountPicker from './CabinetAccountPicker';

export default function ApplicationCabinetOwner({ application, onRefresh }) {
  const { tokenEmployee, loadApplications } = useContext(LayoutContext);
  const [open, setOpen] = useState(false), [owner, setOwner] = useState(null);
  const [busy, setBusy] = useState(false), [error, setError] = useState('');
  const [attached, setAttached] = useState(null);
  useEffect(() => { setAttached(null); setOpen(false); setOwner(null); setError(''); }, [application.id]);
  const current = application.cabinet_owner || attached;
  const save = async () => {
    if (!owner || busy) return;
    setBusy(true); setError('');
    try {
      await APIAttachApplicationCabinet(application.id, owner.id, tokenEmployee);
      setAttached(owner); setOpen(false);
      (onRefresh || loadApplications)?.();
    } catch (e) {
      const data = e?.response?.data;
      setError(typeof data?.detail === 'string' ? data.detail
        : data?.cabinet_client_id?.[0] || 'Не удалось привязать. Проверьте владельца и связи чата.');
    } finally { setBusy(false); }
  };
  return <Stack spacing={0.75} onClick={e => e.stopPropagation()} sx={{ mt: 1, mb: 1.5, py: 0.5, minWidth: 0 }}>
    <Typography level="body-xs" sx={{ overflowWrap: 'anywhere' }}>
      Кабинет: {current?.label || (application.client ? `аккаунт ID ${application.client}` : 'не привязан')}
    </Typography>
    {!current && !application.client && <Button size="sm" variant="soft" color="warning" startDecorator={<PersonAddAltRounded sx={{ fontSize: 17 }} />}
      sx={{ alignSelf: 'flex-start', maxWidth: '100%', minHeight: 34, px: 1.5, borderRadius: '10px', whiteSpace: 'normal', textAlign: 'left' }}
      onClick={() => { setOwner(null); setError(''); setOpen(true); }}>Привязать к кабинету</Button>}
    <Modal open={open} onClose={() => { if (!busy) setOpen(false); }}>
      <ModalDialog sx={{ width: 500, maxWidth: 'calc(100vw - 32px)' }}>
        <Typography level="title-md">Заявка #{application.id}: владелец кабинета</Typography>
        <CabinetAccountPicker token={tokenEmployee} value={owner} onChange={setOwner} disabled={busy} />
        <Typography level="body-sm">Проверьте номер входа и аккаунт. После привязки заказчик увидит заявку, доступные материалы и её клиентскую переписку.</Typography>
        {error && <Typography color="danger" role="alert">{error}</Typography>}
        <Stack direction="row" spacing={1}>
          <Button variant="plain" disabled={busy} onClick={() => setOpen(false)}>Отмена</Button>
          <Button disabled={!owner} loading={busy} onClick={save}>Подтвердить привязку</Button>
        </Stack>
      </ModalDialog>
    </Modal>
  </Stack>;
}